import { randomRPCTesnet } from 'utils/helpers';

export const POLLING_INTERVAL = 10000;

export const TOKEN_ADDRESS = process.env.REACT_APP_TOKEN_ADDRESS;
export const DECIMAL_SCALE = Number(process.env.REACT_APP_DECIMAL_SCALE);
export const TOKEN_NAME = process.env.REACT_APP_TOKEN_NAME;
export const TOKEN_TYPE = process.env.REACT_APP_TOKEN_TYPE;

export const TYPE_OF_ANT_DESIGN = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  IMG_DONE: 'done'
};

// const LIST_BSC_TESTNET = [
//   'https://data-seed-prebsc-1-s1.binance.org:8545/',
//   'https://data-seed-prebsc-2-s1.binance.org:8545/',
//   'https://data-seed-prebsc-1-s2.binance.org:8545/',
//   'https://data-seed-prebsc-2-s2.binance.org:8545/',
//   'https://data-seed-prebsc-1-s3.binance.org:8545/',
//   'https://data-seed-prebsc-2-s3.binance.org:8545/'
// ];

// export const LIST_NETWORK_RPC_TESTNET: any = {
//   97: randomRPCTesnet(LIST_BSC_TESTNET),
//   80001: 'https://rpc-mumbai.maticvigil.com/',
//   4: 'https://rinkeby.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161'
// };

export const LIST_NETWORK_RPC_MAINNET: any = {
  56: 'https://bsc-dataseed.binance.org/',
  // 137: 'https://rpc-mainnet.maticvigil.com/',
  // 1: 'https://mainnet.infura.io/v3/50f6131e95134c0fba1a009b561a31d9'
};

export const NETWORK_CHAIN_ID = {
  BSC: 97,
};

export const METAMASK_DEEPLINK = 'https://metamask.io/download';
export const BRIDGE_URL = 'https://pancakeswap.bridge.walletconnect.org';
export const NETWORK_URL_BSC = 'https://bsc-dataseed.binance.org/';

export const BSCMainnetChainId = '0x38';
export const BSCMainnetChainIdDec = 56;
export const BSCTestnetChainId = '0x61';
export const BSCTestnetChainIdDec = 97;

export const EtherMainnetChainIdDec = 1;
export const EtherTestnetChainId = '0x4';
export const EtherTestnetChainIdDec = 4;

export const CHAIN_INFO: any = {
  [BSCMainnetChainIdDec]: {
    name: 'Binance Smart Chain',
    valueString: BSCMainnetChainIdDec.toString(),
    textWarning: 'Binance Smart Chain - Mainnet',
    url: 'https://bscscan.com',
    suffixToken: 'BEP-20',
    explorerName: 'BSCscan',
    suffixKey: '',
    shortName: 'BSC'
  },
  [BSCTestnetChainIdDec]: {
    name: 'Binance Smart Chain Testnet',
    valueString: BSCTestnetChainIdDec.toString(),
    textWarning: 'Binance Smart Chain - Testnet',
    url: 'https://testnet.bscscan.com',
    suffixToken: 'BEP-20',
    explorerName: 'BSCscan',
    suffixKey: '',
    shortName: 'BSC'
  },
  [EtherMainnetChainIdDec]: {
    name: 'Ethereum',
    valueString: EtherMainnetChainIdDec.toString(),
    textWarning: 'Ethereum - Mainnet',
    url: 'https://etherscan.io',
    suffixToken: 'ERC-20',
    explorerName: 'Etherscan',
    suffixKey: '_ETH',
    shortName: 'ETH'
  },
  [EtherTestnetChainIdDec]: {
    name: 'Ethereum Testnet (Rinkeby)',
    valueString: EtherTestnetChainIdDec.toString(),
    textWarning: 'Ethereum (Rinkeby) - Testnet',
    url: 'https://rinkeby.etherscan.io',
    suffixToken: 'ERC-20',
    explorerName: 'Etherscan',
    suffixKey: '_ETH',
    shortName: 'ETH'
  }
};

export const APP_NETWORKS_SUPPORT: any = {
  [EtherMainnetChainIdDec]: {
    details: {
      chainId: `0x${(+EtherMainnetChainIdDec).toString(16)}`,
      chainName: CHAIN_INFO[EtherMainnetChainIdDec].name,
      nativeCurrency: {
        name: 'ETH',
        symbol: 'ETH',
        decimals: 18
      },
      rpcUrls: [LIST_NETWORK_RPC_MAINNET[EtherMainnetChainIdDec]],
      blockExplorerUrls: [CHAIN_INFO[EtherMainnetChainIdDec].url]
    }
  },
  [BSCMainnetChainIdDec]: {
    details: {
      chainId: `0x${(+BSCMainnetChainIdDec).toString(16)}`,
      chainName: CHAIN_INFO[BSCMainnetChainIdDec].name,
      nativeCurrency: {
        name: 'BNB',
        symbol: 'BNB',
        decimals: 18
      },
      rpcUrls: [LIST_NETWORK_RPC_MAINNET[BSCMainnetChainIdDec]],
      blockExplorerUrls: [CHAIN_INFO[BSCMainnetChainIdDec].url]
    }
  },

  // [EtherTestnetChainIdDec]: {
  //   details: {
  //     chainId: `0x${(+EtherTestnetChainIdDec).toString(16)}`,
  //     chainName: CHAIN_INFO[EtherTestnetChainIdDec].name,
  //     nativeCurrency: {
  //       name: 'ETH',
  //       symbol: 'ETH',
  //       decimals: 18
  //     },
  //     rpcUrls: [LIST_NETWORK_RPC_TESTNET[EtherTestnetChainIdDec]],
  //     blockExplorerUrls: [CHAIN_INFO[EtherTestnetChainIdDec].url]
  //   }
  // },
  // [BSCTestnetChainIdDec]: {
  //   details: {
  //     chainId: `0x${(+BSCTestnetChainIdDec).toString(16)}`,
  //     chainName: CHAIN_INFO[BSCTestnetChainIdDec].name,
  //     nativeCurrency: {
  //       name: 'BNB',
  //       symbol: 'BNB',
  //       decimals: 18
  //     },
  //     rpcUrls: [LIST_NETWORK_RPC_TESTNET[BSCTestnetChainIdDec]],
  //     blockExplorerUrls: [CHAIN_INFO[BSCTestnetChainIdDec].url]
  //   }
  // }
};
